"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.eye_off = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var eye_off = function eye_off(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'eye-off-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M0.0522265 9.54209C1.6059 5.59954 5.20899 2.76714 9.74967 2.76714C14.2903 2.76714 17.8941 5.59948 19.4478 9.54209C19.5174 9.7188 19.5174 9.91534 19.4478 10.092C17.8941 14.0347 14.2903 16.867 9.74967 16.867C5.20899 16.867 1.6059 14.0346 0.0522265 10.092C-0.0174088 9.91534 -0.0174088 9.7188 0.0522265 9.54209ZM1.5608 9.81707C2.96742 13.1017 5.99435 15.367 9.74967 15.367C13.505 15.367 16.5326 13.1017 17.9392 9.81707C16.5326 6.53244 13.505 4.26714 9.74967 4.26714C5.99435 4.26714 2.96742 6.53239 1.5608 9.81707Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M9.75 7.5C8.50736 7.5 7.5 8.50736 7.5 9.75C7.5 10.9926 8.50736 12 9.75 12C10.9926 12 12 10.9926 12 9.75C12 8.50736 10.9926 7.5 9.75 7.5ZM6 9.75C6 7.67893 7.67893 6 9.75 6C11.8211 6 13.5 7.67893 13.5 9.75C13.5 11.8211 11.8211 13.5 9.75 13.5C7.67893 13.5 6 11.8211 6 9.75Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M1.21967 18.2803C0.926777 17.9874 0.926777 17.5126 1.21967 17.2197L17.2197 1.21967C17.5126 0.926777 17.9874 0.926777 18.2803 1.21967C18.5732 1.51256 18.5732 1.98744 18.2803 2.28033L2.28033 18.2803C1.98744 18.5732 1.51256 18.5732 1.21967 18.2803Z',
    fill: '#4B5563'
  }));
};

exports.eye_off = eye_off;